module.exports = __webpack_public_path__ + "img/160.6b81db68.jpg";